import type { IncomingMessage } from 'http';

import { ProductPageDependenciesB2BQuery } from '@/domains/productDiscovery/ProductPage/graphql/productPageDependenciesB2B/generated/productPageDependeciesB2B.generated';
import { MainProductDataFragment } from '@/domains/productDiscovery/ProductPage/graphql/productPageMain/generated/productPageMain.generated';
import type { ContextParams } from '@/domains/productDiscovery/ProductPage/interfaces/ContextParams.model';
import type { MarketDetail } from '@/domains/productDiscovery/ProductPage/interfaces/Detail.model';
import type { Market } from '@/domains/productDiscovery/ProductPage/interfaces/Market';

export const PRODUCT_PAGE_INIT = 'product/PRODUCT_PAGE_INIT';
export const GET_DETAIL = 'product/GET_DETAILS';
export const GET_DETAIL_SUCCESS = 'product/GET_DETAILS_SUCCESS';
export const SET_DETAIL = 'product/SET_DETAIL';

export const GRAPHQL_SUCCESS = 'product/GRAPHQL_SUCCESS';

export interface GetDetail {
  type: typeof GET_DETAIL;
  queryParams: ContextParams;
  massLandingVersion?: string;
  req?: IncomingMessage;
}

export interface GetDetailSuccess<M extends Market = 'b2c' | 'b2b'> {
  type: typeof GET_DETAIL_SUCCESS;
  detail: MarketDetail<M>;
  version?: 'V2-B2C' | 'V1';
}

export interface SetDetail<M extends Market = 'b2c' | 'b2b'> {
  type: typeof SET_DETAIL;
  detail: MarketDetail<M>;
  version: 'V2-B2C';
}

export const setDetail = <M extends Market = 'b2c' | 'b2b'>(
  detail: MarketDetail<M>,
): SetDetail<M> => ({
  type: SET_DETAIL,
  detail,
  version: 'V2-B2C',
});

export type Action<M extends Market> =
  | GetDetail
  | GetDetailSuccess<M>
  | SetDetail<M>;

export type GraphQLSuccessPayload = ProductPageDependenciesB2BQuery & {
  mainData: MainProductDataFragment;
};
export type GraphqlSuccess = {
  type: typeof GRAPHQL_SUCCESS;
  payload: GraphQLSuccessPayload;
};
